import { computed, getCurrentInstance } from 'vue'

export function useComponentId(suffix?: string) {
  const instance = getCurrentInstance()

  const id = (instance?.attrs?.id as string) ?? instance?.uid

  return computed(() => {
    if (id) {
      return suffix ? `${id}-${suffix}` : `${id}`
    }

    return suffix
  })
}
